import React from 'react';
import { DROPDOWN_STYLES } from '../constants/masterStyles';
import { useTranslation } from 'react-i18next';
import { headerNavbarTranslation } from '../../navigation/navigationTranslation';

export const MasterEmptyState: React.FC<{isNursery: boolean}> = ({ isNursery }) => {
const { t } = useTranslation()
  return(
    <div style={DROPDOWN_STYLES.emptyState}>
      <div style={DROPDOWN_STYLES.emptyStateTitle}>
        {t(headerNavbarTranslation.DropdownSearch.empty.line1)}
      </div>
      <div style={DROPDOWN_STYLES.emptyStateText}>
        {isNursery ? t(headerNavbarTranslation.DropdownSearch.empty.lineGuarderia) : t(headerNavbarTranslation.DropdownSearch.empty.line2)}
        <a
          href="mailto:desarrollodepartners-es@edenred.com"
          style={DROPDOWN_STYLES.emptyStateLink}
        >
          {t(headerNavbarTranslation.DropdownSearch.empty.email)}
        </a>
      </div>
    </div>
  )
};
